/*=============================================== PropsItem component ===============================================*/

import { Fragment } from "react"
import { Link } from "react-router-dom"
import { Section, Text, Hr, capitalize, uuid } from "tsx-library-julseb"

import { StyledHr } from "components/PropsItems/styles"
import type { PropsItemsProps } from "components/PropsItems/types"

const PropsItems = ({ items, isExtending }: PropsItemsProps) => {
    return (
        <Section gap="l">
            <Text tag="h3">Props</Text>

            {isExtending && (
                <Text>
                    Here, we are extending the{" "}
                    <Link to={isExtending}>
                        {capitalize(isExtending.split("/")[2])}
                    </Link>{" "}
                    component props.
                </Text>
            )}

            {items.map(item => {
                if (item === "separator") return <Hr key={uuid()} />

                if (item === "separator-small") return <StyledHr key={uuid()} />

                return (
                    <Fragment key={uuid()}>
                        {item.title && <Text tag="h4">{item.title}</Text>}

                        {item.componentIntro &&
                            (typeof item.componentIntro === "string" ? (
                                <Text>{item.componentIntro}</Text>
                            ) : (
                                item.componentIntro
                            ))}

                        {!item.isOnlyExtending && (
                            <Section gap="xxs" as="div">
                                <Text tag="h5">{item.subtitle}</Text>

                                {item.intro && <Text>{item.intro}</Text>}

                                {item.required && (
                                    <Text tag="small">
                                        <Text tag="em">
                                            This prop is required.
                                        </Text>
                                    </Text>
                                )}

                                <Text>
                                    <Text tag="strong">Type: </Text>
                                    {item.type.toLowerCase()}
                                </Text>

                                {item.possible && (
                                    <Text tag="p">
                                        <Text tag="strong">
                                            Possible values:{" "}
                                        </Text>

                                        {item.possible.map(
                                            (possible, index) => (
                                                <Fragment key={uuid()}>
                                                    <code>{possible}</code>
                                                    {item.possible &&
                                                    index !==
                                                        item.possible.length - 1
                                                        ? " | "
                                                        : ""}
                                                </Fragment>
                                            )
                                        )}
                                    </Text>
                                )}

                                {item.possibleString && (
                                    <Text tag="p">
                                        <Text tag="strong">
                                            Possible values:{" "}
                                        </Text>
                                        {item.possibleString}
                                    </Text>
                                )}

                                {item.default && (
                                    <Text>
                                        <Text tag="strong">
                                            Default value:{" "}
                                        </Text>

                                        {typeof item.default === "string" ||
                                        typeof item.default === "number" ? (
                                            <code>{item.default}</code>
                                        ) : (
                                            item.default
                                        )}
                                    </Text>
                                )}
                            </Section>
                        )}
                    </Fragment>
                )
            })}
        </Section>
    )
}

export default PropsItems
